import { MachineLearningExtractionClient } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { AsyncOperationBuilderWithoutState } from 'utilities/api-helper';
import { machineLearningExtractionClient } from '../api-clients';
import { TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { constants } from './constants';
import { PredictionGroupingDtoKeys } from './types';

const actionCreator = actionCreatorFactory('prediction-table-settings');

export const setColumnOrderAction = actionCreator<PredictionGroupingDtoKeys[]>(constants.SET_COLUMN_ORDER);
export const setColumnSizeAction = actionCreator<TableColumnWidthInfoGeneric<PredictionGroupingDtoKeys>[]>(
	constants.SET_COLUMN_SIZES
);

export async function getPredictionsBySerialNumber(serialNumber: string) {
	return await AsyncOperationBuilderWithoutState(
		apiClient => (apiClient as MachineLearningExtractionClient).getPredictionsBySerialNumber(serialNumber),
		machineLearningExtractionClient
	);
}

export async function getPredictions() {
	return await AsyncOperationBuilderWithoutState(
		apiClient => (apiClient as MachineLearningExtractionClient).getPredictions(),
		machineLearningExtractionClient
	);
}
